import { useState } from 'react'

import { BoxImportButton } from './BoxImportButton'
import type { ProviderImportButtonProps } from './CloudImportButton'
import { DropboxImportButton } from './DropboxImportButton'
import { GoogleDriveImportButton } from './GoogleDriveImportButton'

const OrDivider = () => (
  <div className="text-ink-subtle flex items-center gap-3 text-xs">
    <span className="h-px flex-1 bg-zinc-950/10" />
    or
    <span className="h-px flex-1 bg-zinc-950/10" />
  </div>
)

// One import at a time across every provider, so two pickers never add files at once.
export const CloudImportButtons = ({
  addFiles,
  onImportChange,
  disabled,
}: ProviderImportButtonProps) => {
  const [isImporting, setIsImporting] = useState(false)
  const reportImportChange = (isRunning: boolean) => {
    setIsImporting(isRunning)
    onImportChange?.(isRunning)
  }
  const buttonProps = {
    addFiles,
    onImportChange: reportImportChange,
    disabled: disabled || isImporting,
  }
  return (
    <div className="hidden flex-col gap-3 has-[button]:flex">
      <OrDivider />
      <div className="flex flex-col gap-2 sm:flex-row">
        <DropboxImportButton {...buttonProps} />
        <GoogleDriveImportButton {...buttonProps} />
        <BoxImportButton {...buttonProps} />
      </div>
    </div>
  )
}
